import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Box, Grid } from "@motorata/base-ui.components.atoms._atoms";
import Accordion from "@motorata/base-ui.components.molecules.accordion";
import Button from "@motorata/base-ui.components.atoms.button";
import { findTypeOfEquipment, translate } from "@motorata/base-ui.data";
import { Label } from "@motorata/base-ui.components.atoms.typography";

const TypeButton = ({ type, state, setState, label }) => {
  return <Button type={type === state ? "primary" : "secondary"} onClick={() => setState(type)}>
    {label}
  </Button>;
};

const OfferContentEquipment = ({ equipment }) => {
  const [type, setType] = useState("");
  const [state, setState] = useState({
    security: [],
    comfort: [],
    assistant: [],
    audio: []
  });

  useEffect(() => {
    let security = []
    let comfort = []
    let assistant = []
    let audio = []

    equipment?.map(el => {
      const type = findTypeOfEquipment(el)
      if(type === "security")
        security = [...security, el]
      if(type === "comfort")
        comfort = [...comfort, el]
      if(type === "assistant")
        assistant = [...assistant, el]
      if(type === "audio")
        audio = [...audio, el]
    })

    setState({
      security,
      comfort,
      assistant,
      audio
    })

    let initType = ""
    if(security.length > 0)
      initType = "security"
    else if(comfort.length > 0)
      initType = "comfort"
    else if(assistant.length > 0)
      initType = "assistant"
    else if(audio.length > 0)
      initType = "audio"

    setType(initType)
  }, [])

  if (!equipment || equipment.length === 0)
    return <></>;

  return (
    <Accordion title="Wyposażenie" wrapperProps={{ marginBottom: "S" }}>
      <ButtonsWrapper>
        {
          state.security.length > 0 &&
          <TypeButton type="security" state={type} setState={setType} label="Bezpieczeństwo" />
        }
        {
          state.comfort.length > 0 &&
          <TypeButton type="comfort" state={type} setState={setType} label="Komfort" />
        }
        {
          state.assistant.length > 0 &&
          <TypeButton type="assistant" state={type} setState={setType} label="Systemy wspomagające" />
        }
        {
          state.audio.length > 0 &&
          <TypeButton type="audio" state={type} setState={setType} label="Audio i multimedia" />
        }
      </ButtonsWrapper>
      <Content>
        {
          type === "security" &&
          <>
            {
              state.security.map(el =>
                <Label key={el} type="secondary" icon="check" iconColor="primary">{translate(el)}</Label>
              )
            }
          </>
        }
        {
          type === "comfort" &&
          <>
            {
              state.comfort.map(el =>
                <Label key={el} type="secondary" icon="check" iconColor="primary">{translate(el)}</Label>
              )
            }
          </>
        }
        {
          type === "assistant" &&
          <>
            {
              state.assistant.map(el =>
                <Label key={el} type="secondary" icon="check" iconColor="primary">{translate(el)}</Label>
              )
            }
          </>
        }
        {
          type === "audio" &&
          <>
            {
              state.audio.map(el =>
                <Label key={el} type="secondary" icon="check" iconColor="primary">{translate(el)}</Label>
              )
            }
          </>
        }
      </Content>
    </Accordion>
  );
};

export default OfferContentEquipment;

const ButtonsWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.XS};
  margin-bottom: ${({ theme }) => theme.space.S};
  
  @media (max-width: 800px){
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px){
    display: grid;
    grid-template-columns: 1fr;
  }
`;

const Content = styled(Grid)`
  grid-gap: ${({ theme }) => theme.space.XS};
  grid-template-columns: 1fr 1fr;

  @media (max-width: 600px){
    grid-template-columns: 1fr;
  }
`;
